import Vue from 'vue';
import {setupCalendar} from 'v-calendar/src/utils';

Vue.use(setupCalendar, {});
